let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("K8dIZ")).then(() => parcelRequire('hePYz'));